import icons from './antIcons';
import { systemFolderType } from '../../../shared/constants/systemFolderType';

const defaultColor = '#424242';
const systemFolderColor = '#ff6b6b';
const oneDriveFolderColor = '#0A61C9';
const googleDriveFolderColor = '#0A61C9';
const soundFilesExtensions = ['aac', 'aiff', 'flac', 'm4a', 'ogg', 'mp3', 'wav', 'wma'];
const pictureFilesExtensions = ['gif', 'png', 'jpg', 'jpeg', 'bmp', 'svg'];
const videoFilesExtensions = ['avi', 'flv', 'wmv', 'mov', 'mp4'];
const archiveFilesExtensions = ['tar', 'zip', 'gz', 'bz2', 'rar'];
const booksFilesExtensions = ['pdf', 'epub', 'fb2'];

function matchFileExtensions(filename, extensions) {
  const extensionsRegExp = `(${extensions.join('|')})`;
  return extensions.some((o) => new RegExp(`^.*\.${extensionsRegExp}$`).test(filename.toLowerCase()));
}

export function getIcon(resource) {
  let systemColor = systemFolderColor;

  if (resource.isSystemFolder && +resource.systemFolderType === systemFolderType.INSURED_ONEDRIVE_FOLDER) {
    systemColor = oneDriveFolderColor;
  } else if (resource.isSystemFolder && +resource.systemFolderType === systemFolderType.INSURED_GOOGLEDRIVE_FOLDER) {
    systemColor = googleDriveFolderColor;
  }

  if (resource.type === 'dir') {
    return {
      icon: icons.folder,
      color: resource.isSystemFolder ? systemColor : defaultColor,
    };
  } else if (matchFileExtensions(resource.name, soundFilesExtensions)) {
    return { icon: icons.volumeUp, color: '#e53935' };
  } else if (matchFileExtensions(resource.name, pictureFilesExtensions)) {
    return { icon: icons.image, color: '#e53935' };
  } else if (matchFileExtensions(resource.name, videoFilesExtensions)) {
    return { icon: icons.ondemandVideo, color: '#e53935' };
  } else if (matchFileExtensions(resource.name, archiveFilesExtensions)) {
    return { icon: icons.archive, color: '#616161' };
  } else if (matchFileExtensions(resource.name, booksFilesExtensions)) {
    return { icon: icons.book, color: '#e53935' };
  } else {
    return { icon: icons.insertDriveFile, color: '#616161' };
  }
}
